import { Button } from 'primereact/button'
import styled from 'styled-components'

export const FavoritesTabContainer = styled.div`
  border: 1px solid #cecece;
  border-radius: 15px;
  padding: 0 1rem;
`

export const TabPanelWrapper = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding: 0 0.5rem;
`

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
export const ListItem = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  //   flex-wrap: wrap;
  //   row-gap: 15px;
  column-gap: 10px;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 0.5px solid #cecece;

  //   &:hover {
  //     background: #fafafa;
  //   }

  &:last-child {
    border-bottom: none;
  }

  .fav-content {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .fav-name-loc {
      flex: 1;
      display: flex;
      flex-direction: column;
      row-gap: 2px;

      .fav-name {
        font-weight: 700;
        width: 350px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .fav-location {
        font-size: 12px;
        width: 350px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }

    .fav-block,
    .fav-floor,
    .fav-detail {
      flex: 1;
      width: 175px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
`

export const ListActionArea = styled.div`
  display: flex;
  align-items: center;
  //   flex: 1 0 auto;
  column-gap: 15px;
`

export const ReservationButton = styled(Button)`
  width: 175px;
  height: 40px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`
